export const getTodayStr = () => new Date().toLocaleDateString('es-CL').split('-').reverse().join('-');

export const formatDate = (date) => date.toLocaleDateString('es-CL').split('-').reverse().join('-');

